import React from 'react'
import type { IconDefaultProps } from '../../../models/types'

const SubtitlesOffIcon = ({
  className,
  color
}: IconDefaultProps): JSX.Element => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 17.088 17.088'
      className={className || 'rf-w-4 rf-h-4'}
    >
      <g
        transform='translate(-41.7 -41.7)'
      >
        <path
          d='M521.309,212.887v.016l.016-.016Z'
          transform='translate(-468.172 -167.105)'
          fill='none'
        />
        <path
          d='M42.892,52.629V47.859c0-1.866.355-3.089,1.116-3.851s1.985-1.116,3.851-1.116h4.769a7.124,7.124,0,0,1,2.926.488l.886-.886a7.6,7.6,0,0,0-3.812-.795H47.859c-2.2,0-3.694.466-4.694,1.466S41.7,45.657,41.7,47.859v4.769a7.6,7.6,0,0,0,.794,3.812l.886-.886A7.129,7.129,0,0,1,42.892,52.629Z'
          transform='translate(0 0)'
          fill={color || "#FFF"}
        />
        <path
          d='M157.118,147.4v4.769c0,1.865-.355,3.088-1.116,3.85s-1.986,1.117-3.851,1.117h-4.769a7.333,7.333,0,0,1-2.835-.448l-.893.893a7.745,7.745,0,0,0,3.728.747h4.769c2.2,0,3.694-.466,4.694-1.467s1.466-2.491,1.466-4.693V147.4a7.741,7.741,0,0,0-.747-3.728l-.893.893A7.328,7.328,0,0,1,157.118,147.4Z'
          transform='translate(-99.522 -99.537)'
          fill={color || "#FFF"}
        />
        <path
          d='M498.667,572.3H497.2a.6.6,0,1,0,0,1.192h1.471a.6.6,0,0,0,0-1.192Z'
          transform='translate(-444.052 -517.947)'
          fill={color || "#FFF"}
        />
        <path
          d='M252.716,573.492a.6.6,0,1,0,0-1.192h-3.195l-1.192,1.192Z'
          transform='translate(-201.702 -517.947)'
          fill={color || "#FFF"}
        />
        <path
          d='M375.711,464.192h4.395a.6.6,0,0,0,0-1.192h-4.189l-.775.775A.6.6,0,0,0,375.711,464.192Z'
          transform='translate(-325.491 -411.254)'
          fill={color || "#FFF"}
        />
        <path
          d='M192.3,463a.6.6,0,1,0,0,1.192h.123L193.612,463Z'
          transform='translate(-146.423 -411.254)'
          fill={color || "#FFF"}
        />
        <path
          d='M201.268,170.421a1.643,1.643,0,0,0-.113-.636,1.6,1.6,0,0,0-.3-.469,1.926,1.926,0,0,0-.418-.342,4.719,4.719,0,0,0-.479-.256q-.244-.113-.479-.213a3.17,3.17,0,0,1-.42-.216,1.057,1.057,0,0,1-.3-.263.568.568,0,0,1-.11-.35.683.683,0,0,1,.049-.258.537.537,0,0,1,.15-.209.728.728,0,0,1,.251-.136,1.131,1.131,0,0,1,.352-.049,1.679,1.679,0,0,1,.474.063,2.633,2.633,0,0,1,.38.141q.164.077.277.143a.391.391,0,0,0,.164.066.116.116,0,0,0,.082-.028.185.185,0,0,0,.047-.089.858.858,0,0,0,.023-.155q.007-.094.007-.23t0-.2a.906.906,0,0,0-.016-.136.378.378,0,0,0-.028-.087.342.342,0,0,0-.063-.08.784.784,0,0,0-.192-.117,2.258,2.258,0,0,0-.333-.127,2.956,2.956,0,0,0-.4-.089,2.873,2.873,0,0,0-.432-.033,2.832,2.832,0,0,0-.791.108,1.858,1.858,0,0,0-.647.326,1.573,1.573,0,0,0-.436.549,1.725,1.725,0,0,0-.162.767,1.7,1.7,0,0,0,.113.652,1.612,1.612,0,0,0,.293.472,1.916,1.916,0,0,0,.411.342,4.315,4.315,0,0,0,.474.256q.244.113.474.213a3.055,3.055,0,0,1,.41.216,1.118,1.118,0,0,1,.293.263.567.567,0,0,1,.113.354.778.778,0,0,1-.066.324.647.647,0,0,1-.19.244.9.9,0,0,1-.3.152,1.392,1.392,0,0,1-.4.054,2.12,2.12,0,0,1-.6-.077,2.773,2.773,0,0,1-.448-.171,3.253,3.253,0,0,1-.307-.171.39.39,0,0,0-.185-.077.135.135,0,0,0-.082.026.175.175,0,0,0-.056.087.7.7,0,0,0-.031.16q-.009.1-.009.244a1.606,1.606,0,0,0,.026.331.351.351,0,0,0,.087.176.992.992,0,0,0,.2.141,2.076,2.076,0,0,0,.345.152,3.319,3.319,0,0,0,.476.124,3.112,3.112,0,0,0,.584.052,3.033,3.033,0,0,0,.873-.122c.054-.016.107-.034.158-.054l1.123-1.123A2.02,2.02,0,0,0,201.268,170.421Z'
          transform='translate(-151.893 -121.397)'
          fill={color || "#FFF"}
        />
        <path
          d='M400.9,171.6h.016l1.009-1.009h-3.783a.125.125,0,0,0-.08.026.2.2,0,0,0-.056.084.633.633,0,0,0-.035.157,2.07,2.07,0,0,0-.012.239,1.958,1.958,0,0,0,.012.232.627.627,0,0,0,.035.155.219.219,0,0,0,.056.087.118.118,0,0,0,.08.028h1.52v1.254l1.239-1.239Z'
          transform='translate(-347.759 -125.815)'
          fill={color || "#FFF"}
        />
        <path
          d='M469.37,350.961a.13.13,0,0,0,.03.085.214.214,0,0,0,.1.061.991.991,0,0,0,.19.038,3.161,3.161,0,0,0,.6,0,.991.991,0,0,0,.19-.038.214.214,0,0,0,.1-.061.13.13,0,0,0,.03-.085v-1.64l-1.239,1.239Z'
          transform='translate(-417.472 -300.285)'
          fill={color || "#FFF"}
        />
        <path
          d='M61.748,46.575a.6.6,0,0,0-.843,0l-.817.817-.855.855L57.983,49.5l-.873.873-.792.792L55.08,52.4l-3.934,3.934-1.192,1.192-3.114,3.114-.855.855-.851.851a.6.6,0,0,0,.843.843l.86-.86.859-.859,1.338-1.338,1.192-1.192,4.854-4.854,1.239-1.239L60.063,49.1l.859-.859.826-.826A.6.6,0,0,0,61.748,46.575Z'
          transform='translate(-3.181 -4.588)'
          fill={color || "#FFF"}
        />
      </g>
    </svg>
  )
}

export default SubtitlesOffIcon
